import '@aab/sc-aab-spinner';
import { FC } from 'react';

type SpinnerProps = {
  // size will be multiplied by 8/ 3=> 3*8=24px
  size?: number;
  text?: string;
  hideOverlay?: boolean;
};

export const Spinner: FC<SpinnerProps> = ({
  size = 3,
  text = '',
  hideOverlay = true
}) => (
  <aab-spinner
    hide-overlay={hideOverlay || undefined}
    size={size}
    text={text}
    data-testid="spinner"
  />
);
